import {deleteWalletPinService, getWalletPinStatusService, resetWalletPinService} from "@/services/wallet-pin.service";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";

const WALLET_PIN_KEY = ["wallet-pin"] as const;

export const useWalletPinStatus = (walletId: string) =>
  useQuery({
    queryKey: [...WALLET_PIN_KEY, walletId],
    queryFn: async () => {
      const {data} = await getWalletPinStatusService(walletId);
      if (data === undefined) throw new Error("No data");
      return data;
    },
    enabled: !!walletId,
  });

export const useResetWalletPin = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (walletId: string) => resetWalletPinService(walletId),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: WALLET_PIN_KEY});
    },
  });
};

export const useDeleteWalletPin = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (walletId: string) => deleteWalletPinService(walletId),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: WALLET_PIN_KEY});
    },
  });
};
